import React from "react";

import PropTypes from "prop-types";

Tag.propTypes = {
  /** Color of the tag. See list of colors here: https://tailwindcss.com/docs/customizing-colors */
  noFlex: PropTypes.bool,
  color: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  className: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  rounded: PropTypes.bool,
  /** Any other properties or events that will be passed on to the button instance. */
  rest: PropTypes.any,
};

Tag.defaultProps = {
  color: "gray",
  rounded: false,
};

export default function Tag({
  noFlex,
  color,
  className,
  children,
  rounded,
  ...rest
}) {
  let klass = (noFlex ? "" : "inline-flex") + " py-1 px-2 font-medium";

  if (typeof color === "object") {
    klass += ` bg-${color.background} text-${color.text}`;
  } else {
    klass += ` bg-${color}-100 text-${color}-800`;
  }

  if (rounded) {
    klass += " px-2 py-1 rounded-full";
  }

  if (className) {
    klass += ` ${className}`;
  }

  return (
    <span className={klass} {...rest}>
      {children}
    </span>
  );
}
